import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-market-trades',
  templateUrl: './market-trades.component.html',
  styleUrls: ['./market-trades.component.scss']
})
export class MarketTradesComponent implements OnInit {

  busy: boolean = false;
  modalBusy:boolean = false;
  showError: boolean = false;
  errorMsg: string = "Oops! Looks like something went wrong, please contact support if this issue persists";
  
  constructor() { }

  ngOnInit(): void {
  }

}
